var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.userPermissions.indexOf('dept_detail')>-1)?_c('el-link',{attrs:{"type":"primary","target":"_blank"},on:{"click":function($event){return _vm.goDeptDetail(_vm.info.id)}}},[_vm._v(" "+_vm._s(_vm.info.name || '')+" ")]):_c('span',[_vm._v(_vm._s(_vm.info.name || ''))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }